import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { DxDataGridComponent, DxDropDownBoxComponent } from 'devextreme-angular';
import { TypeDechetRwdto } from 'src/api/models';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-type-dechet-rw-select',
  templateUrl: './type-dechet-rw-select.component.html',
  styleUrls: ['./type-dechet-rw-select.component.css']
})
export class TypeDechetRwSelectComponent implements OnInit, OnDestroy {
  @ViewChild('dxDropDown') dropDown: DxDropDownBoxComponent;
  @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
  @Select(ControlPanelStore.typesDechetsRW$) typesDechetsRW$: Observable<TypeDechetRwdto[]>;

  @Input() width: number;
  @Input() widthPopUp: number = 250;

  @Input() typeDechetRWId: number;
  @Output() typeDechetRWIdChange = new EventEmitter<number>();

  @Input() cell: any;

  InitId = null;

  TypesDechetsRW: TypeDechetRwdto[] = [];
  ColumnName = [];

  td: Subscription;

  constructor(private panelLayoutService: PanelLayoutService,
    private translate: TranslateService,
    private devExtremeTranslationService: DevExtremeTranslationService) {
    // Instanciate Globalize for DevExtreme components
    this.devExtremeTranslationService.loadLanguage(this.translate.getBrowserLang());

    this.translate.get(
      [
        'Code',
        'Description',
      ]
      ).subscribe(translations => {
        this.ColumnName.push(translations['Code']);
        this.ColumnName.push(translations['Description']);
      });
  }

  ngOnInit() {
    if(this.typeDechetRWId != null) {
      this.InitId = JSON.parse(JSON.stringify(this.typeDechetRWId));
    }
    this.td = this.typesDechetsRW$.subscribe(res => {
      if (res != null) {
        this.TypesDechetsRW = res;
      }
    });
  }

  ngOnDestroy() {
    this.td?.unsubscribe();
  }

  updateInfo(event) {
    this.typeDechetRWId = event.currentSelectedRowKeys.length == 1 ? event.currentSelectedRowKeys[0].Id : this.typeDechetRWId;
    if (!!this.cell && this.InitId != this.typeDechetRWId) {
      this.cell.setValue(this.typeDechetRWId);
    }
    this.typeDechetRWIdChange.emit(this.typeDechetRWId);

    if(this.typeDechetRWId != null) {
      this.dropDown.instance.close();
    }
  }

  onOpened() {
    if(this.typeDechetRWId == null) {
      this.dataGrid.instance.clearSelection();
    }

    document.body.childNodes.forEach(element => {
      if(element.nodeType == 1) {
        if((element as HTMLElement).className.includes("dx-dropdowneditor-overlay")) {
          (element.childNodes[0] as HTMLElement).style.width = `${this.widthPopUp}px`;
        }
      }
    });
  }
}
